export enum ItemEarnSource {
  Purchase = 'Purchase',
  DailyLogin = 'DailyLogin',
  QuestionAnswerReward = 'QuestionAnswerReward',
  MissionRewardClaim = 'MissionRewardClaim',
  GameReward = 'GameReward',
  ExternalReward = 'ExternalReward',
  EarnedItemsCollect = 'EarnedItemsCollect', // Unused - To be removed NOVA-4430
  QaGrant = 'QaGrant',
  LevelUp = 'LevelUp',
  GiftClaim = 'GiftClaim',
  GardenMissionRewardClaim = 'GardenMissionRewardClaim',
  GardenMissionCelebration = 'GardenMissionCelebration',
  GardenHarvest = 'GardenHarvest'
}
